import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SurveysSandbox } from '@app/surveys/sandboxes/surveys.sandbox';
import { TranslateService } from '@ngx-translate/core';
import { Language, RxjsComponent, TranslateLabelPipe } from '@smooved/core';
import { CheckInput, MultiSelectInput } from '@smooved/ui';
import { startWith, takeUntil } from 'rxjs/operators';
import { QuestionValidatorType } from '../../enums/question-validator-type.enum';
import { Selection } from '../../interfaces/meta/questions/selection';
import { SelectionOption } from '../../interfaces/meta/questions/selection-option';

@Component({
    selector: 'app-question-selection-component',
    templateUrl: './question-selection.component.html',
})
export class QuestionSelectionComponent extends RxjsComponent implements OnInit {
    @Input() public question: Selection;
    @Input() public group: UntypedFormGroup;

    public label: string;

    public selectionOptions: MultiSelectInput<any>[] = [];
    public checkOptions: CheckInput<any>[] = [];
    public category: string;
    public required: boolean;

    constructor(
        public readonly surveySandbox: SurveysSandbox,
        private readonly translateService: TranslateService,
        private readonly translateLabelPipe: TranslateLabelPipe,
        private readonly cdr: ChangeDetectorRef
    ) {
        super();
    }

    public ngOnInit(): void {
        this.translateService.onLangChange
            .pipe(startWith({ lang: this.translateService.currentLang }), takeUntil(this.destroy$))
            .subscribe(({ lang }) => {
                this.selectionOptions = this.convertMultiSelectionOption(this.question?.options, lang as Language);

                this.checkOptions = this.question?.options?.map((option) => {
                    return {
                        id: `${this.question.id}-${option.value}`,
                        name: `${this.question.id}-${option.value}`,
                        label: this.translateLabelPipe.transform(option.label),
                        value: option.value,
                    };
                });
                this.cdr.detectChanges();
            });

        this.required = this.question.validators?.some((validator) => validator.type === QuestionValidatorType.Required);
    }

    private convertMultiSelectionOption(selectionOptions: SelectionOption[], lang: Language): MultiSelectInput<any>[] {
        return selectionOptions.map((option) => {
            return {
                id: `${this.question.id}-${option.value}`,
                name: this.question.id,
                label: this.translateLabelPipe.transform(option.label),
                description: option.subLabel ? this.translateLabelPipe.transform(option.subLabel) : null,
                value: option.value,
                children: option.children ? this.convertMultiSelectionOption(option.children, lang) : null,
            };
        });
    }
}
